import React from 'react';
import Menu from '@material-ui/core/Menu';

const MenuComponent = props => {
  const { activeMenu, anchorEl, handleClose, className, children, ...rest } = props;
  return (
    <div>
      <Menu
        id={activeMenu}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        className={`${className ? className : ''} react-menu`}
        getContentAnchorEl={null}
        {...rest}>
        {children}
      </Menu>
    </div>
  );
};

export default MenuComponent;